import React, { memo } from "react";
import styles from "./style.css";

export const Spinner = memo(props => {
  const { dark = false, foreground: fg, background: bg, size = 1, borderSize: bs = 1, ...rest } = props;

  const borderSize = bs || size;
  const foreground = fg || (dark ? "black" : "white");
  const background = bg || (dark ? "rgba(0,0,0,0.2)" : "rgba(255, 255, 255, 0.2)");

  const border = `${0.25 * borderSize}rem solid ${background}`;
  const borderFg = `${0.25 * borderSize}rem solid ${foreground}`;

  const height = `${1.5 * size}rem`;
  const width = height;

  return (
    <div
      {...rest}
      class={styles.container}
      style={{
        width,
        height,
        borderTop: border,
        borderRight: border,
        borderBottom: border,
        borderLeft: borderFg
      }}
    >
      <span style={{ width, height }}></span>
    </div>
  );
});
